// Maps each metric-catalog key to a HugeIcons bulk icon for KPI tiles.
import {
  Coins01Icon, EuroIcon, ShoppingCart01Icon, TrendingUpIcon, ChartLineIcon,
  ReceiptIcon, FunnelIcon, HeartIcon, EyeIcon, Cursor01Icon, Target01Icon,
  UserGroupIcon, UserGroup02Icon, UserPlusIcon, Layers01Icon, HandshakeIcon,
  PlayIcon, Briefcase01Icon, PercentIcon, Search01Icon, Globe02Icon,
} from "@hugeicons-pro/core-bulk-rounded";
import type { IconSvgElement } from "@hugeicons/react";

export const METRIC_ICON: Record<string, IconSvgElement> = {
  spend: Coins01Icon,
  revenue: EuroIcon,
  orders: ShoppingCart01Icon,
  roas: TrendingUpIcon,
  mer: ChartLineIcon,
  aov: ReceiptIcon,
  conversion_rate: FunnelIcon,
  paid_engagement_rate: HeartIcon,
  impressions: EyeIcon,
  clicks: Cursor01Icon,
  ctr: Target01Icon,
  reached_accounts: UserGroupIcon,
  organic_engagement_rate: HeartIcon,
  follower_growth: UserPlusIcon,
  content_pieces: Layers01Icon,
  influencer_collabs: HandshakeIcon,
  video_views: PlayIcon,
  applications: Briefcase01Icon,
  cost_per_application: Briefcase01Icon,
  net_revenue_growth: TrendingUpIcon,
  new_customers: UserPlusIcon,
  cpa_new_customer: Coins01Icon,
  cpa: Coins01Icon,
  spend_pct_of_new_revenue: PercentIcon,
  branded_search: Search01Icon,
  website_visitors: Globe02Icon,
};

export function metricIcon(key: string): IconSvgElement {
  return METRIC_ICON[key] ?? ChartLineIcon;
}
